import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../shared/shared.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {TreatmentInfoService} from "./treatment-info.service";
import {DtoTreatmentInfoBaseItems} from "./models/DtoTreatmentInfoBaseItems";
import {DtoTreatmentInfo} from "./models/DtoTreatmentInfo";


@Component({
    selector: 'app-treatment-info',
    template: require('./treatment-info.component.html'),
    styles: [require('./treatment-info.component.css')]
})

@AutoUnsubscribe()
export class TreatmentInfoComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    periodDisabled: boolean;
    subSalesgroupDisabled: boolean;
    data: DtoTreatmentInfo;
    filterHeaderConfig: PageHeaderBarConfig;
    periodItems: Array<{ text: string, value: number }> = [
        {text: "Deze week", value: 1},
        {text: "Deze maand", value: 2},
        {text: "Dit jaar", value: 3},
        {text: "Laatste 2 jaar", value: 4},
        {text: "Variabele periode", value: 5}
    ];
    baseItems: DtoTreatmentInfoBaseItems;
    excelFilename: string;
    filterForm: FormGroup;
    pshbConfig: PageSubheaderBarConfig;

    columnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '120px'
        },
        {
            key: 'description',
            label: 'Behandeling',
            type: 'string',
            width: '*'
        },
        {
            key: 'amount',
            label: 'Aantal',
            type: 'number',
            width: '120px'
        },
        {
            key: 'retailAmount',
            label: 'Omzet incl.',
            type: 'number',
            width: '120px',
            format: '{0:c2}'
        },
        {
            key: 'retailAmountEx',
            label: 'Omzet excl.',
            type: 'number',
            width: '120px',
            format: '{0:c2}'
        },
        {
            key: 'amountMale',
            label: 'Aantal heren',
            type: 'number',
            width: '120px'
        },
        {
            key: 'retailAmountMale',
            label: 'Omzet heren',
            type: 'number',
            width: '120px',
            format: '{0:c2}'
        },
        {
            key: 'amountFemale',
            label: 'Aantal dames',
            type: 'number',
            width: '120px'
        },
        {
            key: 'retailAmountFemale',
            label: 'Omzet dames',
            type: 'number',
            width: '120px',
            format: '{0:c2}'
        },
        {
            key: 'treatmentPercentage',
            label: 'Behandel %',
            type: 'number',
            width: '120px'
        },
        {
            key: 'malePercentage',
            label: 'Heren %',
            type: 'number',
            width: '120px'
        },
        {
            key: 'femalePercentage',
            label: 'Dames %',
            type: 'number',
            width: '120px'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ss: SharedService,
                private sds: SharedDataService,
                private ds: TreatmentInfoService) {
    }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'management', isLastStep: false },
            { text: 'detailgegevens behandelingen', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterHeaderConfig = {
            title: 'INSTELLINGEN',
            buttonDefinition: [
                {
                    description: 'RESULTATEN',
                    clickEventType: 'search',
                    isSmall: false
                }
            ]
        };

        this.filterForm = this.fb.group({
            salesgroupId: 0,
            subSalesgroupId: 0,
            employeeId: 0,
            departmentId: 0,
            userId: 0,
            periodId: 2,
            from: null,
            untill: null
        });


        this.filterForm.get('periodId').valueChanges.subscribe(newVal => {
            this.setFilterPeriod(newVal);
            this.clearData();
        });

        this.filterForm.get('userId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('salesgroupId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('subSalesgroupId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('employeeId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('from').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('untill').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.pshbConfig = {
            title: 'BEHANDELINGEN INCLUSIEF BTW',
            buttonDefinition: [
                {
                    clickEventType: 'excel',
                    description: 'EXCEL',
                    isSmall: false
                }
            ]
        };

        this.ds.getTreatmentInfoBaseItems().subscribe((res: DtoTreatmentInfoBaseItems) => {
            this.baseItems = res;
            setTimeout(() => {
                this.setFilterPeriod(2);
                this.loadData();
            });
        });
    }

    clearData() {
        this.grid.clearData();
        this.data = null;
    }

    loadData() {
        this.excelFilename = `Detailgegevens behandelingen.xlsx`;
        this.clearData();
        this.ds.getTreatmentInfo({
            userId: this.filterForm.get('userId').value,
            departmentId: this.filterForm.get('departmentId').value,
            from: this.filterForm.get('from').value,
            employeeId: this.filterForm.get('employeeId').value,
            untill: this.filterForm.get('untill').value,
            salesgroupId: this.filterForm.get('salesgroupId').value,
            subSalesgroupId: this.filterForm.get('subSalesgroupId').value
        }).subscribe((res: DtoTreatmentInfo) => {
            this.data = res;
            if (this.data.lines.length > 0) {
                this.grid.showData(this.data.lines);
            }
        });
    }

    setFilterPeriod(periodKind: number) {
        if (periodKind == 1) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addDaysToDate(this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()), 6) });
        } else if (periodKind == 2) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfMonth(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfMonth(this.ss.getCurrentDate()) });
        } else if (periodKind == 3) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfYear(this.ss.getCurrentDate()) });
        } else if (periodKind == 4) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addYearsToDate(this.ss.getLastDayOfYear(this.ss.getCurrentDate()), 1) });
        } else if (periodKind == 5) {
            this.periodDisabled = false;
        }
    }

    getSubSalesgroups() {
        if (this.baseItems && this.filterForm.get('salesgroupId').value && this.filterForm.get('salesgroupId').value > 0) {
            this.subSalesgroupDisabled = false;
            return this.baseItems.salesgroups.find(x => x.id == this.filterForm.get('salesgroupId').value).treatmentSubSalesgroups;
        } else {
            this.subSalesgroupDisabled = true;
        }
        return null;
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        }
    }

    pshbBtnClicked(event) {
        if (event == 'excel') {
            this.grid.saveAsExcel();
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/treatment-info/treatment-info.component.ts